import emailjs from '@emailjs/browser';

const email_service_id = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const email_template_id = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const email_second_template_id = process.env.REACT_APP_EMAILJS_SECOND_TEMPLATE_ID;
const email_public_key = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

console.log('EMAILJS SERVICE ID:', email_service_id);
console.log('EMAILJS TEMPLATE ID:', email_template_id);
console.log('EMAILJS PUBLIC KEY:', email_public_key);

export const sendWelcomeEmail = async payload => {
  const response = await emailjs.send(
    email_service_id,
    email_template_id,
    payload,
    email_public_key,
  );

  if (!response || response.status !== 200) {
    throw new Error('Error sending welcome email');
  }

  return response;
};

export const sendReservationMail = async payload => {
  const response = await emailjs.send(
    email_service_id,
    email_second_template_id,
    payload,
    email_public_key,
  );

  if (!response || response.status !== 200) {
    throw new Error('Error sending welcome email');
  }

  return response;
};
